import { isArray } from 'util';
import { EventType } from '../event-type';

export class EventTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new EventType(
        json.code,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(EventTypeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/event-type.builder.ts